var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKantanIcon = function SvgKantanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 13.233h9.2a.6.6 0 0 1 .6.6v1.2c0 2.87-2.33 5.2-5.2 5.2s-5.2-2.33-5.2-5.2v-1.2a.6.6 0 0 1 .6-.6ZM12 10.767a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
  }))));
};
export default SvgKantanIcon;